<template>
    <div class="card card-round border dashboard-widget dashboard-widget--client-invoice">
        <div class="card-header"><h6 class="fw-bold mb-0 dashboard-widget__title">
            <span class="dashboard-widget__icon" v-html="sidebarSvg.clientInvoice"></span>
            <span>{{ $t('Client Payment Position') }}</span>
        </h6></div>
        <div class="card-body">
            <div class="payment-position__metrics">
                <div class="payment-position__metric text-center text-info">
                    <div>
                        <span class="fw-bold payment-position__amount" :class="{ 'payment-position__amount--negative': Number(data.notPaid) < 0 }">{{projectInfo.currencyId?.sign}}{{ReformatNumber(data.notPaid)}}</span>
                    </div>
                    <div >
                        <small> {{ $t('Invoices') }}</small>
                    </div>
                </div>
                <div class="payment-position__metric text-center text-success">
                    <div>
                        <span class="fw-bold payment-position__amount" :class="{ 'payment-position__amount--negative': Number(data.paid) < 0 }">{{projectInfo.currencyId?.sign}}{{ReformatNumber(data.paid)}}</span>
                    </div>
                    <div >
                        <small> {{ $t('Paid') }}</small>
                    </div>
                </div>
                <div class="payment-position__metric text-center text-delta">
                    <div>
                        <span class="fw-bold payment-position__amount" :class="{ 'payment-position__amount--negative': Number(data.delta) < 0 }">{{projectInfo.currencyId?.sign}}{{ReformatNumber(data.delta)}}</span>
                    </div>
                    <div >
                        <small> {{ $t('Delta') }}</small>
                    </div>
                </div>
            </div>
            <div class="progress">
                <div class="progress-bar bg-success" role="progressbar" :style="{ width : data.percentage + '%' }"></div>
                <div class="progress-bar bg-info" role="progressbar" :style="{ width :  (100 -data.percentage)+ '%' }" ></div>
            </div>
        </div>
    </div>
</template>

<script>
import {DashboardGetPaymentPositionToClient} from '@/actions/projectActions.js'
import {ReformatNumber} from '../../helpers/utilities.js'
import { sidebarSvg } from '@/components/deluxe/DeluxeSidebar.vue'
export default {
    name : 'PaymentPositionToClient',
    props : ['projectInfo'],
    data(){
        return {
            data : {
                paid :0, 
                notPaid :0, 
                delta : 0,
                percentage : 0
            },
            sidebarSvg
            
        }
    },
    mounted : async function(){
        const self = this

        const response = await DashboardGetPaymentPositionToClient(self.projectInfo._id)
        if(!response)
            return
        self.data = {
            paid : response.data.paid,
            notPaid : response.data.notPaid,
            delta : response.data.paid - response.data.notPaid,
            percentage : Math.round((response.data.paid/response.data.notPaid )*100)
        }
    },
    methods :{
        ReformatNumber,
    }
    
} 
</script>

<style scoped>
.payment-position__metrics {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem 1rem;
    margin-bottom: 0.5rem;
}

/* Wrap whole metrics, never individual digits or decimal places. */
.payment-position__metric {
    flex: 1 1 max-content;
    min-width: 0;
    max-width: 100%;
    overflow-x: auto;
}

.payment-position__amount {
    display: inline-block;
    white-space: nowrap;
    overflow-wrap: normal;
    word-break: normal;
    font-variant-numeric: tabular-nums;
}

.payment-position__amount.payment-position__amount--negative {
    color: #c62828 !important;
}

body.dark .payment-position__amount.payment-position__amount--negative,
.deluxe-layout.dark .payment-position__amount.payment-position__amount--negative {
    color: #ff9a9a !important;
}
</style>
